import { useSelector } from 'react-redux';
import { Store } from 'src/redux/Store';
import { t } from 'src/lib/language';
import FormSingleSelect, { SelectItem } from 'src/components/Control/FormControls/FormSingleSelect';
import { FORM_ID } from 'src/models/FormModel';
import { ORGANISATION_TYPES } from 'src/constants/OrganisationTypes';

interface Props {
  disabled?: boolean,
  form: FORM_ID,
  name: string,
  onChange: (id:string) => void,
  value?: string,
}

const OrganisationTypeSelector = (props: Props) => {
  const {
    disabled, form, name, onChange, value,
  } = props;

  const lang = useSelector((state: Store) => state.language.language ?? 'en');

  const getItems = () => [
    { id: ORGANISATION_TYPES.business, text: ORGANISATION_TYPES.business },
    { id: ORGANISATION_TYPES.church, text: ORGANISATION_TYPES.church },
    { id: ORGANISATION_TYPES.general, text: ORGANISATION_TYPES.general },
    { id: ORGANISATION_TYPES.school, text: ORGANISATION_TYPES.school },
  ] as SelectItem[];

  return (
    <FormSingleSelect
      disabled={disabled}
      form={form}
      items={getItems()}
      label={t(lang, 'forms.organisation.organisation_type')}
      name={name}
      onChange={onChange}
      value={value || ''}
      noMarginTop />
  );
};

export default OrganisationTypeSelector;
